/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges} from '@angular/core';
import {findConversionTypeDescription} from './custom-event-commons';

@Component({
  standalone: false,
  selector: 'adn-custom-event-conversion-type-description',
  template: `<span *ngIf="description">{{ description }}</span>`
})
export class CustomEventConversionTypeDescriptionComponent implements OnChanges {
  @Input() conversionType: string | null;
  description = '';

  ngOnChanges(): void {
    this.description = findConversionTypeDescription(this.conversionType);
  }
}
